import { render, staticRenderFns } from "./reject-refund.vue?vue&type=template&id=28e5e966&scoped=true&"
import script from "./reject-refund.vue?vue&type=script&lang=js&"
export * from "./reject-refund.vue?vue&type=script&lang=js&"
import style0 from "./reject-refund.vue?vue&type=style&index=0&id=28e5e966&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5e966",
  null
  
)

export default component.exports